function carousel(name, autoplay, interval) {
    document.querySelectorAll(name).forEach(carousel => {
        const splide = new Splide(carousel, {
            autoplay: autoplay,
            interval: interval,
            pauseOnHover: true,
            rewind: true
        }).mount();

        // Hide arrows if only one slide
        if (splide.length === 1 || splide.Components.Slides.get().length === 1) {
            const arrows = carousel.querySelector('.splide__arrows');
            if (arrows) {
                arrows.style.display = 'none';
            }
        }
    });
}